import { ModelBase } from './base';

export class Product extends ModelBase {
  public name: string;
  public category_id: number;
  public sku: string;
  public ean: string;
  public description: string;
  public short_description: string;
  public price_excluding_vat: number;
  public price_including_vat: number;
  public vat: VAT;
  public in_shop: boolean;
  public is_active: boolean;
  public quantity: number = 0;
  public image: string;
}

export class VAT extends ModelBase {
  public name: string;
  public value: number;
}


// WEBPACK FOOTER //
// ./src/models/product.ts